export default __webpack_public_path__ + "images/KA.9138dd1.png";